module.exports = __webpack_public_path__ + "static/img/default_golden.d539b101.png";